import { render, staticRenderFns } from "./TargetItemLarge.vue?vue&type=template&id=34e2e0c1&scoped=true&"
import script from "./TargetItemLarge.vue?vue&type=script&lang=js&"
export * from "./TargetItemLarge.vue?vue&type=script&lang=js&"
import style0 from "./TargetItemLarge.vue?vue&type=style&index=0&id=34e2e0c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2e0c1",
  null
  
)

export default component.exports